<template>
  <div>
    <!-- <div class="page"> -->
        <div class="container wider">
          <header class='header'>
            <h1>No published articles at this time.</h1>
            <p>We're working on something exciting. Stay tuned!</p>
          </header>
        </div>
    <!-- </div> -->
    <Footer />
  </div>
</template>

<script>
import Blog from './Blog';

export default Blog;
</script>

<style lang="scss" scoped src="./Blog.scss"></style>